/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
export * as draftIerc1822Sol from "./draft-IERC1822.sol";
export { IERC1967__factory } from "./IERC1967__factory";
